import { showConfirmationModal } from 'actions/confirmationModal';
import { getGraphQLClient } from 'utilities/graphql';

import ArchiveVideos from './ArchiveVideos.graphql';

export function archiveVideosGraphQL(items, isArchived) {
  return dispatch => {
    const gqlClient = getGraphQLClient();

    const action = isArchived ? 'archiving' : 'unarchiving';
    const actionPastTense = isArchived ? 'archived' : 'unarchived';

    gqlClient
      .mutate({
        mutation: ArchiveVideos,
        variables: {
          videoIds: items.map(item => item.id),
          isArchived,
        },
        update: (cache, { data }) => {
          const updatedVideos = data?.result?.videos;

          if (updatedVideos) {
            updatedVideos.forEach(video => {
              const normalizedId = cache.identify({
                id: video.id,
                __typename: 'RegularUserVideo',
              });

              cache.evict({ id: normalizedId });
              cache.gc();
            });

            cache.gc();
          }
        },
      })
      .then(() => {
        switch (items.length) {
          case 0:
            dispatch(showConfirmationModal(`Oops! Error ${action} videos`));
            break;
          case 1:
            dispatch(
              showConfirmationModal(
                `${items[0].name} successfully ${actionPastTense}`
              )
            );
            break;
          default:
            dispatch(
              showConfirmationModal(
                `${items.length} videos successfully ${actionPastTense}`
              )
            );
        }
      })
      .catch(() =>
        dispatch(showConfirmationModal(`Oops! Error ${action} videos`))
      );
  };
}
